/*
 * @Author: bobo 350910378@qq.com
 * @Date: 2022-05-16 20:54:38
 * @LastEditors: bobo 350910378@qq.com
 * @LastEditTime: 2023-04-18 18:20:41
 * @FilePath: \baishu_react_ui\src\components\dashboard\BsyDashboardCustomApp\index.jsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React, { Component } from "react";
import './index.css';

class BsyAppExportPane extends Component {
    static defaultProps = {
        customApp: {}
    }

    constructor(props) {
        super(props)
        this.state = {}
        this.element = React.createRef();
    }

    componentDidMount() {
        const that = this;
        this.exportPane = new window.FX.AppExportPane({
            renderEl: window.$("<div/>").appendTo(this.element.current),
            onStopEdit: function () {
                const label = this.onChangeLabel();
                that.props.dialogRef.element.current.querySelector('.dialog-footer .blue span').innerText = React.language('ok') + label;
            }
        })
    }


    render() {

        return (
            <div className="bsy-app-export-pane" ref={this.element}></div>
        )
    }
}

export default BsyAppExportPane;
